import React, { Component } from 'react';

declare var UIkit;

export class Alert extends Component {

  state = {
    title: "", message: ""
  };

  onOpen = (title, message) => {
    this.setState({
      title: title, message: message      
    }, () => {
      UIkit.modal( this.modal ).show();  
    });
  }

  onClose = () => {

  }

  render = () => {
    return (
      <div ref={modal => this.modal = modal} className="uk-flex-top" {...{'uk-modal': 'container: false;'}} >
        <div className="uk-modal-dialog uk-modal-body uk-margin-auto-vertical uk-border-rounded">
            <button className="uk-modal-close-default" type="button" {...{'uk-close': ''}}></button>
            <div className="uk-padding-small">
              <h3 className="uk-text-center uk-text-gothic">
                { this.state.title }
              </h3>
              <p dangerouslySetInnerHTML={{__html: this.state.message}}>
              </p>
            </div>
        </div>
      </div>
    );
  }

}
